import { msg } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { syncGameInfo } from 'modules/overlay-v2/store/game-info/actions';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from 'store/store';
import { useDispatchWithToast } from 'store/use-dispatch-with-toast';
import UDButton from 'ud-ui/components/button';
import { selectPopupIsLoaded } from 'modules/overlay-v2/store/overlay/selectors';
import { syncTime } from 'modules/overlay-v2/store/time/actions';
import { selectTime } from 'modules/overlay-v2/store/time/selectors';
import useGameInfo from 'modules/overlay-v2/ui/hooks/use-game-info';
import usePopupMessenger from 'modules/overlay-v2/ui/hooks/use-popup-messenger';
import useTimer from 'modules/overlay-v2/ui/hooks/use-timer';

function SyncStateButton() {
  const dispatch = useDispatch<AppDispatch>();
  const dispatchWithToast = useDispatchWithToast();
  const { match, isSynchronization } = useGameInfo();
  const [prevStateSynchonization, setPrevStateSynchonization] = useState(false);

  const { hasPopups, send } = usePopupMessenger();
  const popupIsLoaded = useSelector(selectPopupIsLoaded);
  const gameInfo = useGameInfo();
  const time = useSelector(selectTime);
  const { timer } = useTimer();

  // Промис обоих запросов — кнопке: она заперта до ответа сама (ранний `return` по флагу как замок убран).
  const handleClickSync = useCallback(() => {
    if (!match) return;
    const matchId = match.id;
    // Раньше провал молчал (кроме мёртвой ветки «не заданы таймы», удалённой в IMGM-1549).
    return Promise.all([
      dispatchWithToast(syncGameInfo({ matchId }), { error: msg`Не удалось синхронизировать данные матча` }),
      dispatch(syncTime({ matchId })),
    ]);
  }, [dispatch, dispatchWithToast, match]);

  useEffect(() => {
    // Данные пришли с сервера (синхронизация только что закончилась) — раздаём их окнам.
    if (prevStateSynchonization && popupIsLoaded && hasPopups) {
      send({ type: 'syncState', time, timer, gameInfo });
    }

    setPrevStateSynchonization(isSynchronization);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSynchronization]);

  return (
    // `isSynchronization` — и синхронизация при открытии матча: запрос идёт не только отсюда.
    <UDButton disabled={isSynchronization} onClick={handleClickSync} loading={isSynchronization} variant={'dark'}>
      <Trans>Синхронизировать состояние</Trans>
    </UDButton>
  );
}

export default SyncStateButton;
